<div class="shared-slide-toggle" [formGroup]="parent">
  <label *ngIf="label !== ''">{{ label }}</label>
  <mat-slide-toggle class="slide-toggle" (change)="setControlValue($event)" [formControlName]="control">
  </mat-slide-toggle>
</div>
